import type { Strings } from "./en";

/** Oʻzbek (lotin). Rasmiy imlo: oʻ, gʻ (U+02BB). Kirill yozuvi taklif qilinmaydi. */
export const uz: Strings = {
  nav: {
    how: "Qanday ishlaydi",
    industries: "Sohalar",
    pricing: "Narxlar",
    faq: "Savol-javob",
    signIn: "Kirish",
    startFree: "Bepul boshlash",
    openApp: "OctoMailni ochish",
    language: "Til",
  },
  landing: {
    hero: {
      eyebrow: "Yangi mijozlar uchun doim ishlaydigan yordamchingiz",
      h1: "Har bir mijozga javob beriladi.",
      lead: "OctoMail email va Telegramdagi har bir yangi xabarni oʻqiydi, bir daqiqa ichida sizning ohangingizda va mijoz tilida javob beradi hamda tafsilotlari yigʻilgan haqiqiy xaridorlarni sizga topshiradi.",
      ctaTrial: "7 kunlik bepul sinovni boshlash",
      ctaSee: "Qanday ishlashini koʻring",
      fine: "Ulanish bepul · Istalgan vaqtda bekor qiling · Gmail va Telegram bilan ishlaydi",
    },
    demo: {
      email: "Email",
      telegram: "Telegram",
      aria: "Namuna suhbat",
      replied: "OctoMail bir daqiqa ichida javob berdi",
      qualified: "Mos mijoz",
      emailConvo: {
        name: "Jasur",
        tag: "Avtomobil",
        customer1: "Assalomu alaykum. 2021-yilgi Chevrolet Malibu hali sotuvdami? Shu hafta oxiri koʻrsam boʻladimi?",
        reply: "Salom Jasur! Ha, Malibu hali sotuvda. Koʻrish vaqtini siz bilan kelishib olamiz: shanba yoki yakshanba ertalab qulaymi?",
        customer2: "Shanba ertalab boʻladi.",
      },
      telegramConvo: {
        name: "Nigora",
        tag: "Vannaxona",
        customer1: "Assalomu alaykum! Vannaxonani taʼmirlash qancha turadi? Yunusoboddamiz.",
        reply: "Salom Nigora! Yozganingiz uchun rahmat. Narxini tafsilotlarni bilganimizdan soʻng aytamiz: vannaxona taxminan qanchalik katta va qachon boshlamoqchisiz?",
        customer2: "Taxminan 6 m². Keyingi oy.",
      },
    },
    does: {
      eyebrow: "Nima qiladi",
      title: "OctoMail siz uchun nima qiladi",
      items: [
        { title: "Har bir xabarni oʻqiydi", body: "Email va Telegram, kechayu kunduz, xabar kelishi bilan." },
        { title: "Bir daqiqa ichida javob beradi", body: "Sizning ohangingizda va mijoz tilida: oʻzbek, rus, ingliz va boshqalar." },
        { title: "Tafsilotlarni yigʻadi", body: "Manzil, muddat yoki byudjet kabi kerakli maʼlumotlarni soʻraydi, shunda har bir mijoz tayyor holda keladi." },
        { title: "Muhimini sizga topshiradi", body: "Shikoyatlar va mavjud mijozlar xabari ogohlantirish bilan toʻgʻridan-toʻgʻri sizga keladi." },
      ],
    },
    day: {
      eyebrow: "Qanday ishlaydi",
      title: "Birinchi xabardan tayyor mijozgacha, siz ishlayotganingizda",
      steps: [
        { time: "9:41", title: "Mijoz yozadi", message: "Salom! Oshxonani taʼmirlash kerak, Chilonzordamiz.", note: "Telegramda, siz ishda boʻlgan paytda." },
        { time: "9:42", title: "OctoMail javob beradi", message: "Salom Dilnoza! Qachon boshlamoqchisiz va oshxona taxminan qanchalik katta?", note: "Oʻzbek tilida, sizning ohangingizda. Narx va vaʼdalarsiz." },
        { time: "9:50", title: "Tayyor mijoz sizda", message: "", note: "Faqat vaqtingizga arziydiganlarga qayta qoʻngʻiroq qilasiz." },
      ],
      lead: [
        { k: "Ish", v: "Oshxona taʼmiri" },
        { k: "Hudud", v: "Chilonzor" },
        { k: "Boshlash", v: "Keyingi oy" },
      ],
      statusLabel: "Holat",
      status: "Mos",
    },
    control: {
      eyebrow: "Nazorat sizda",
      title: "U siz uchun ishlaydi, sizning oʻrningizga emas",
      items: [
        "Email: birinchi javobni siz tasdiqlaysiz, keyin u oʻzi ishlaydi.",
        "Telegram: qaysi chatlarga javob berishini oʻzingiz tanlaysiz.",
        "Oʻzingiz javob berishingiz bilan OctoMail oʻsha suhbatdan chetga chiqadi.",
        "U hech qachon narx aytmaydi, chegirma bermaydi yoki sana vaʼda qilmaydi. Shikoyatlar va mavjud mijozlar toʻgʻridan-toʻgʻri sizga keladi.",
      ],
    },
    industries: {
      eyebrow: "Mijozlar sizga qanday kelsa, shunga moslangan",
      title: "Nima sotmang, birinchi javob yutadi.",
      sub: "Haqiqiy soʻrovlar, siz yozgandek javoblar, avtomatik. Mana bu sizning sohangizda qanday koʻrinadi.",
      inbound: "Kelgan xat",
      inYourVoice: "OctoMail · siz yozgandek",
      seeFor: (x: string) => `OctoMail ${x} uchun →`,
      items: {
        dealerships: {
          label: "Avtosalonlar",
          inbound: "2021 Chevrolet Tracker hali bormi?",
          reply: "Salom Jasur, ha, hali sotuvda. Kelib koʻrish uchun qulay vaqtni kelishamizmi?",
          linkText: "avtosalonlar",
        },
        contractors: {
          label: "Qurilish va taʼmir",
          inbound: "Oshxonani qayta taʼmirlamoqchimiz, qachon kelib koʻra olasiz?",
          reply: "Salom Dilnoza, albatta kelib koʻraman. Oʻlchash uchun ertalab qulaymi yoki tushdan keyin?",
          linkText: "quruvchilar",
        },
        dental: {
          label: "Stomatologiyalar",
          inbound: "Yangi bemorlarni qabul qilasizmi? Tozalash va koʻrik kerak.",
          reply: "Salom Sardor, ha, bajonidil qabul qilamiz. Qaysi kunlar sizga qulay?",
          linkText: "stomatologiyalar",
        },
        auto: {
          label: "Avtoservislar",
          inbound: "Tormoz gʻichirlayapti, shu hafta koʻra olasizmi?",
          reply: "Salom Aziz, albatta koʻramiz. Mashina yuradimi va qaysi kun sizga qulay?",
          linkText: "avtoservislar",
        },
        rv: {
          label: "Karvan va treylerlar",
          inbound: "2022 yilgi Winnebago treyler hali sotuvdami?",
          reply: "Salom Bekzod, ha, hali bor. Kelib koʻrishni xohlaysizmi?",
          linkText: "treyler sotuvchilar",
        },
        sales: {
          label: "Savdo jamoalari",
          inbound: "12 kishilik jamoa uchun dastur tanlayapmiz, batafsil aytib bera olasizmi?",
          reply: "Salom Kamola, jamoangizga koʻrsatib berishdan xursand boʻlaman. Qisqa qoʻngʻiroq uchun qaysi vaqt qulay?",
          linkText: "savdo jamoalari",
        },
      },
    },
    stats: {
      eyebrow: "Tezlik ish keltiradi",
      title: "Birinchi javob bergan biznes odatda yutadi.",
      items: [
        { big: "21×", small: "5 daqiqa ichida javob bersangiz, buyurtmani olish ehtimoli shuncha yuqori" },
        { big: "78%", small: "xaridorlar birinchi javob bergan biznesni tanlaydi" },
        { big: "< 1 daq", small: "OctoMail yangi murojaatga javob berishi uchun, kechayu kunduz" },
      ],
      note: "Soʻrovlarga javob boʻyicha raqamlar soha tadqiqotlaridan (Lead Response Management / Harvard Business Review). Hozir Kanada, AQSh va Oʻzbekistondagi birinchi bizneslarni ulayapmiz. Birinchilar qatoriga qoʻshiling.",
    },
    pricing: {
      eyebrow: "Narxlar",
      title: "Bitta oddiy reja. Kutilmagan xarajatlar yoʻq.",
      sub: "Bitta oʻtkazib yuborilgan buyurtmadan yoʻqotadiganingizdan kam.",
      monthly: "Oylik",
      annual: "Yillik · 25% tejang",
      planName: "OctoMail",
      planSub: "Birorta mijozni oʻtkazib yubormaslik uchun kerak boʻlgan hamma narsa.",
      perMo: (code: string) => `/oy ${code}`,
      billedYearly: (annual: string, code: string) => `Yiliga ${annual} ${code} hisoblanadi`,
      billedMonthly: (code: string) => `Har oy ${code}da toʻlanadi`,
      switchNote: " · yillik rejaga oʻting va 3 oy bepul oling",
      factDay: (rate: string) => `Kuniga taxminan ${rate}`,
      factAdmin: "Yarim stavka administrator oyiga millionlab soʻm turadi",
      factPays: "Bitta buyurtma bilan oʻzini oqlaydi",
      features: [
        "Har bir yangi email va Telegram xabarini oʻqiydi",
        "Haqiqiy xaridorlarni keraksizlardan ajratadi",
        "Sizning ohangingizda, mijoz tilida javob beradi",
        "Gmail va Telegram bilan ishlaydi",
        "Barcha suhbatlar bir joyda",
      ],
      telegramNote: "Telegram ulanishi uchun biznes hisobida Telegram Premium boʻlishi kerak.",
      cta: "7 kunlik bepul sinovni boshlash",
      fine: "7 kun bepul. Qolishga qaror qilmaguningizcha kartadan pul yechilmaydi.",
    },
    faq: {
      eyebrow: "Savollar",
      title: "Yaxshi savollar, toʻgʻri javoblar.",
      items: [
        { q: "Kompyuterni yaxshi bilishim kerakmi?", a: "Yoʻq. Google orqali bir marta kirasiz, qolganini OctoMail oʻzi qiladi. Pochtangizni tekshira olsangiz, undan foydalana olasiz." },
        { q: "Haqiqiy buyurtmani spamdan qanday ajratadi?", a: "OctoMail har bir xatni siz uchun muhim narsalarga qarab oʻqiydi: kim yozgan, nima kerak, muddat, manzil. Haqiqiy soʻrovlarni belgilaydi, spam va shunchaki soʻrab koʻruvchilarni chetga oladi, shunda bir qarashda kimga javob berish kerakligini bilasiz." },
        { q: "Mijoz byudjet yoki muddatni yozmasa-chi?", a: "OctoMail soʻrovni «maʼlumot kerak» deb belgilaydi va faqat yetishmayotgan tafsilotlarni soʻraydigan doʻstona javob tayyorlaydi, shunda suhbat siz quvmasdan ham davom etadi." },
        { q: "U oʻzi javob beradimi?", a: "Ha, gap ham shunda. Emailda OctoMail eng birinchi javobni siz tasdiqlaganingizdan soʻng yangi soʻrovlarga sizning ohangingizda avtomatik javob beradi. Telegramda esa ulaganingiz zahoti siz ruxsat bergan chatlarda yangi mijozlarga javob beradi. U hech qachon narx aytmaydi yoki sana vaʼda qilmaydi, uni istalgan vaqtda oʻchirib qoʻyishingiz mumkin." },
        { q: "Mijozlarim avtomatik ekanini bilib qoladimi?", a: "Yoʻq. Javoblar iliq, oddiy tilda va sizning ohangingizda yoziladi, hech qachon robotdek shablonlar emas. Emailda hech narsa yuborilishidan oldin birinchi javobni koʻrib, oʻzingiz tasdiqlaysiz." },
        { q: "Mening pochtam bilan ishlaydimi?", a: "OctoMail hozir Gmail va Google Workspace bilan ishlaydi. Outlook yoki boshqa xizmatdan foydalanasizmi? support@octoaiverse.com ga yozing, qoʻllab-quvvatlash boshlanishi bilan xabar beramiz." },
        { q: "Pochtam xavfsizmi?", a: "Ha. Biz Googlening rasmiy xavfsiz kirishi orqali ulanamiz. Parolingiz OctoMailga hech qachon tegmaydi va xatlaringiz hech kimga berilmaydi." },
        { q: "Narxi qancha?", a: "Oyiga 99 dollar (USD) yoki yillik toʻlovda tejang. Har bir hisob 7 kunlik bepul sinovdan boshlanadi, qolishga qaror qilmaguningizcha kartadan pul yechilmaydi." },
        { q: "Bekor qilmoqchi boʻlsam-chi?", a: "Istalgan vaqtda ikki bosishda bekor qiling yoki support@octoaiverse.com ga yozing, biz hal qilamiz. Hech qanday toʻsiq yoʻq." },
        { q: "Telegram bilan ishlaydimi?", a: "Ha. OctoMailni Telegram hisobingizga bir marta ulaysiz: Telegram Business sozlamalarida, Chat-botlar boʻlimida. Mijozlaringiz odatdagidek botga emas, sizga yozishda davom etadi, OctoMail esa siz ruxsat bergan chatlarda javob beradi. Buning uchun biznes hisobida Telegram Premium boʻlishi kerak." },
        { q: "Mijozlarimning xabarlari bilan nima boʻladi?", a: "OctoMail ularni faqat murojaatni tushunish va javob yozish uchun oʻqiydi; buning uchun matn Google Gemini orqali qayta ishlanadi. Suhbatlar hisobingiz faol boʻlgan davrda saqlanadi va hisobingizni oʻchirganingizda oʻchiriladi. Bundan tashqari, Telegram chatlari Telegramni uzganingizdan 30 kun oʻtib oʻchiriladi." },
      ],
    },
    footer: {
      tagline: "Har bir mijozga javob beriladi. Siz ishda boʻlganingizda OctoMail email va Telegramdagi mijozlarga javob beradi.",
      socialAria: (label: string) => `OctoAIverse ${label}da`,
      product: "Mahsulot",
      industries: "Sohalar",
      answers: "Javoblar",
      company: "Kompaniya",
      links: {
        contractors: "Qurilish va taʼmir",
        dealerships: "Avtosalonlar",
        dental: "Stomatologiyalar",
        auto: "Avtoservislar",
        rv: "Treyler sotuvchilar",
        sales: "Savdo jamoalari",
        speedToLead: "Javob tezligi nima",
        howFast: "Qanchalik tez javob berish kerak",
        vsReceptionist: "OctoMail va kotib",
        canAi: "AI pochtaga javob bera oladimi",
        contact: "Aloqa",
        privacy: "Maxfiylik",
        terms: "Shartlar",
      },
      copyrightA: (year: number) => `© ${year} OctoMail, `,
      copyrightB: " mahsuloti. Barcha huquqlar himoyalangan.",
    },
  },
  app: {
    loading: "Yuklanmoqda",
    nav: { home: "Bosh sahifa", leads: "Mijozlar", questions: "Savollar", settings: "Sozlamalar", help: "Yordam" },
    shell: { account: "Hisob", signOut: "Chiqish", copyright: (year: number) => `© ${year} OctoMail, OctoAIverse mahsuloti` },
    fmt: { justNow: "hozirgina", minAgo: (m: number) => `${m} daqiqa oldin`, hrAgo: (h: number) => `${h} soat oldin`, dayAgo: (d: number) => `${d} kun oldin`, today: "Bugun", yesterday: "Kecha", generic: "Nimadir xato ketdi." },
    status: { qualified: "Mos", needsInfo: "Maʼlumot kerak", unqualified: "Mos emas", held: "Kutilmoqda", pending: "Navbatda" },
    filters: { filters: "Filtrlar", status: "Holat", all: "Hammasi", qualified: "Mos", needsInfo: "Maʼlumot kerak", category: "Toifa", clearAll: "Tozalash" },
    thread: {
      noHistory: "Hali yozishmalar tarixi yoʻq. Bu soʻrov xabarlarni kuzatish boshlanishidan oldin saralangan boʻlishi mumkin.",
      reply: "Javob", edit: "Tahrirlash", preview: "Koʻrish", copied: "Nusxalandi!", copy: "Nusxalash",
      placeholder: "AI tayyorlagan javobni tahrirlang va Yuboring, yoki oʻzingiz yozing…", replyAria: "Javob matni",
      closedNote: "Bu soʻrov yopilgan. Yana javob yuborish uchun pastda qayta oching.",
      supportsA: "Qoʻllaydi:", bold: "**qalin**", italic: "*kursiv*", supportsB: ", roʻyxatlar va havolalar. Mijozingiz toza, formatlangan xat oladi.",
      sending: "Yuborilmoqda…", sendTo: (name: string) => `${name}ga yuborish`, resetDraft: "AI matniga qaytarish",
      replyWindow: (h: number, m: number) => `Telegram bu yerda yana ${h} soat ${m} daqiqa javob berishga ruxsat beradi.`,
      windowClosed: "Telegram bu chatni OctoMail uchun yopdi (mijozdan 24 soat xabar yoʻq). Telegramdan javob bering.",
      openInTelegram: "Telegramda ochish",
      telegramHint: "Telegram hisobingizdan oddiy xabar sifatida yuboriladi. Formatlash olib tashlanadi.",
      sendErrors: {
        reply_window_closed: "Telegram bu chatni OctoMail uchun yopdi (mijozdan 24 soat xabar yoʻq). Telegramdan javob bering.",
        telegram_not_connected: "Telegram ulanmagan. Uni Sozlamalarda qayta ulang.",
        telegram_cannot_reply: "Telegram OctoMailga javob berishga ruxsat bermayapti. Telegramda: Sozlamalar > Telegram Business > Chat-botlar, Xabarlarni boshqarish ichida javob berishni yoqing.",
        send_failed: "Telegram bu xabarni qabul qilmadi. Qayta urinib koʻring yoki Telegramdan javob bering.",
        subscription_required: "Javob berish uchun faol OctoMail tarifi yoki sinov muddati kerak. Sozlamalardagi Reja va toʻlov boʻlimini tekshiring.",
        body_too_long: "Bu xabar Telegram uchun juda uzun (koʻpi bilan 4096 belgi).",
        body_required: "Avval xabar yozing.",
      },
    },
    msg: { sentOnYourBehalf: "siz nomingizdan yuborildi", openInGmail: "Gmailda ochish →" },
    questions: {
      title: "Savollar", subtitle: "Qaysi soʻrov vaqtingizga arziydi. OctoMail har bir narx soʻrovida shularni qidiradi.",
      add: "Savol qoʻshish", loadingAria: "Savollar yuklanmoqda",
      emptyTitle: "OctoMailga yaxshi mijoz qanday ekanini ayting",
      emptyBody: "OctoMail har bir kelgan soʻrovni shu savollar boʻyicha tekshiradi. Majburiy javoblar yetishmasa, belgilaydi yoki avtomatik soʻrab oladi.",
      adding: "Qoʻshilmoqda…", starterPack: "6 savollik tayyor toʻplam", scratch: "Boshidan boshlash", saveChanges: "Saqlash",
      moveUp: "Yuqoriga", moveDown: "Pastga", edit: "Tahrirlash", editQuestion: "Savolni tahrirlash", delete: "Oʻchirish", deleteQuestion: "Savolni oʻchirish",
      required: "Majburiy", optional: "Ixtiyoriy",
      kinds: { text: "Matn", select: "Tanlov", number: "Raqam", boolean: "Ha / Yoʻq" },
      confirmDelete: "Bu savol oʻchirilsinmi? Buni qaytarib boʻlmaydi.", failDelete: "Oʻchirib boʻlmadi.", failReorder: "Tartibni oʻzgartirib boʻlmadi.", failSeed: "Shablonlarni qoʻshib boʻlmadi.",
      editor: {
        labelLabel: "Savol matni", labelPlaceholder: "masalan, Loyiha manzili qayerda?", kindLabel: "Javob turi",
        hints: { text: "Erkin javob (masalan, manzil, izohlar)", select: "Roʻyxatdan bittasi (masalan, byudjet oraligʻi)", number: "Raqamli qiymat (masalan, kvadrat metr)", boolean: "Bitta ha yoki yoʻq savoli" },
        requiredLabel: "Saralash uchun majburiy", optionsLabel: "Variantlar", optionsHint: "(har qatorda bittadan)",
        optionsPlaceholder: "5 mln soʻmgacha\n5 dan 25 mln soʻmgacha\n25 dan 100 mln soʻmgacha\n100 mln soʻmdan yuqori",
        optionsNote: "Kamida 2 ta variant. Mijozning javobi haqiqiy hisoblanishi uchun shulardan biriga mos kelishi kerak (katta-kichik harf farqsiz).",
        errLabelRequired: "Savol matni majburiy.", errLabelLong: "Savol matni 200 belgidan oshmasligi kerak.", errOptions: "Tanlov savollariga kamida 2 ta variant kerak.",
        failSave: "Saqlab boʻlmadi.", saving: "Saqlanmoqda…", cancel: "Bekor qilish",
      },
    },
    starter: [
      { label: "Bu qanday loyiha?", options: ["Oshxona taʼmiri", "Hammom taʼmiri", "Yertoʻla / qoʻshimcha qurilish", "Tashqi ishlar / tom", "Boshqa"] },
      { label: "Loyiha manzili qayerda?" },
      { label: "Byudjet oraligʻi qancha?", options: ["5 mln soʻmgacha", "5 dan 25 mln soʻmgacha", "25 dan 100 mln soʻmgacha", "100 mln soʻmdan yuqori"] },
      { label: "Qachonga tugatilishi kerak?" },
      { label: "Chizma yoki oʻlchamlaringiz tayyormi?" },
      { label: "Siz bilan qanday bogʻlanish qulay?", options: ["Elektron pochta", "Telefon", "SMS"] },
    ],
    settings: {
      title: "Sozlamalar", subtitle: "Shaxsiy sozlamalar. Ular hisobingizdan tashqariga chiqmaydi.",
      billing: {
        name: "Reja va toʻlov", hint: "Obuna, sinov muddati va toʻlov maʼlumotlari.", loading: "Yuklanmoqda…",
        activeRenews: (d: string) => `Faol, ${d} da yangilanadi`, trialLeft: (n: number) => `Bepul sinov, ${n} kun qoldi`, pastDue: "Toʻlov amalga oshmadi, kartani yangilang", canceled: "Bekor qilingan", noPlan: "Faol reja yoʻq",
        active: "Faol", trialChip: (n: number) => `Bepul sinov · ${n} kun qoldi`, paymentFailed: "Toʻlov amalga oshmadi",
        subscribed: "Obuna boʻldingiz. Rahmat!", cancelled: "Toʻlov bekor qilindi. Pul yechilmadi.",
        perMonth: "oy", perYear: "yil", annualNote: "Oylikka nisbatan uch oy bepul.", monthlyNote: "Istalgan vaqtda bekor qiling. Ikki bosish, toʻsiqsiz.",
        monthly: "Oylik", annual: "Yillik",
        features: ["Cheksiz kiruvchi soʻrovlar", "Siz yozgandek AI javoblar", "Tasdiqlash nazorati bilan Avtopilot", "Kunlik xulosa va soʻrovlar roʻyxati"],
        redirecting: "Yoʻnaltirilmoqda…", subscribe: "Obuna boʻlish", loadingPortal: "Portal ochilmoqda…", manage: "Toʻlovni boshqarish",
      },
      autopilot: {
        name: "Avtopilot", hint: "OctoMail yangi soʻrovlarga avtomatik, siz yozgandek javob beradi. U hech qachon oʻzi narx aytmaydi yoki sanaga vaʼda bermaydi.",
        title: "Yangi soʻrovlarga avtomatik javob", body: "Sifatini koʻrish uchun eng birinchi javobni siz tasdiqlaysiz. Keyin u oʻzi ishlaydi.",
        on: "Yoqilgan. Yangi soʻrovlar avtomatik javob oladi.", off: "Oʻchirilgan. Har bir javobni oʻzingiz koʻrib, yuborasiz.", failed: "Avtopilotni yangilab boʻlmadi.",
      },
      cc: {
        name: "Nusxa (Cc) yuborish", hint: "OctoMail yuborgan har bir javobning nusxasini ikkinchi manzilga (yordamchingiz yoki hamkoringiz) yuboring.", legend: "Nusxa yuborish",
        secondary: "Qoʻshimcha pochta", placeholder: "yordamchi@kompaniya.uz", ccLabel: "Har bir javobda bu manzilga nusxa yuborish", ccHint: "Qabul qiluvchilar nusxa manzilini koʻradi.",
        errNeedEmail: "Qoʻshimcha pochta kiriting yoki nusxa yuborishni oʻchiring.", errInvalid: "Bu toʻgʻri elektron pochtaga oʻxshamaydi.", failSave: "Saqlab boʻlmadi.",
        saving: "Saqlanmoqda…", save: "Sozlamalarni saqlash", saved: "Saqlandi ✓",
      },
      telegram: {
        name: "Telegram",
        hint: "Telegramingizga yozgan mijozlarga OctoMail javob bersin. Telegram Premium kerak.",
        consentTitle: "Ulashdan oldin",
        consentBody: [
          "OctoMail faqat Telegramda (Sozlamalar > Telegram Business > Chat-botlar) siz bergan chatlarni oʻqiydi.",
          "Bu chatlardagi xabarlar matni tushunish va javob yozish uchun Google Gemini ga yuboriladi.",
          "Bu chatlar hisobingiz faol boʻlgan davrda saqlanadi. Hisobingizni istalgan vaqtda oʻchirishingiz mumkin, bunda hammasi oʻchib ketadi, Telegram chatlari esa Telegramni uzganingizdan 30 kun oʻtib oʻchiriladi.",
          "OctoMail hech qachon narx aytmaydi yoki sana vaʼda qilmaydi va siz oʻzingiz javob bergan chatda toʻxtaydi.",
        ],
        consentCheck: "Roziman",
        connect: "Telegramni ulash",
        connecting: "Telegram ochilmoqda…",
        waiting: "Telegramda Start tugmasini bosing va bot koʻrsatmalariga amal qiling. Bu sahifa oʻzi yangilanadi.",
        linkedNotConnected: "Bogʻlandi. Telegramda oxirgi qadam: Sozlamalar > Telegram Business > Chat-botlar > @OctoAIversebot ni qoʻshing.",
        connected: (u: string) => `Ulandi${u ? ` (@${u})` : ""}. Yangi mijozlar avtomatik javob oladi.`,
        cannotReply: "Telegram OctoMailga javob berishga ruxsat bermayapti. Telegramda: Sozlamalar > Telegram Business > Chat-botlar, Xabarlarni boshqarish ichida javob berishni yoqing.",
        deleteAllWarning: "Maslahat: Chat-botlar boʻlimida, Xabarlarni boshqarish ichida \"barcha xabarlarni oʻchirish\"ni oʻchiring. OctoMailga u kerak emas.",
        setupTips: [
          "\"Barcha shaxsiy chatlar, bundan tashqari...\" ni tanlang va \"Kontaktlar\"ni istisno qiling.",
          "Mijozlaringiz botga emas, SIZGA yozishda davom etadi.",
        ],
        usage: (n: number, max: number) => `Bu oy ${max} tadan ${n} ta AI suhbat`,
        failed: "Telegram ulanishini boshlab boʻlmadi.",
        startOver: "Qaytadan boshlash",
        reloadPage: "OctoMail yangilandi. Sahifani qayta yuklang va yana urinib koʻring.",
        needsSubscription: "Telegram uchun faol OctoMail tarifi yoki sinov muddati kerak. Sozlamalardagi Reja va toʻlov boʻlimini tekshiring.",
      },
      more: {
        name: "OctoAIverse’dan yana", hint: "Xabarlaringiz nazoratda. Telefon liniyangiz-chi?", product: "OctoReception", tagline: "Har bir qoʻngʻiroq, javob berilgan.",
        body: "Biznes telefoningizga 24/7 javob beradigan AI kotib: savollarga javob beradi, uchrashuvlarni band qiladi va qoʻngʻiroq tugashi bilan sizga qisqacha SMS yuboradi.",
        cta: "Bepul sinov qoʻngʻirogʻi →", price: "Oyiga 24,95 USD dan · sinash uchun karta shart emas",
      },
      danger: {
        name: "Xavfli hudud", hint: "Hisobingizni, maʼlumotlaringizni va OctoMailning pochtangizga kirishini butunlay oʻchiring.",
        body1A: "OctoMail hisobingizni oʻchirish bu yerda saqlangan hamma narsani (soʻrovlar, xabarlar tarixi, sozlamalar) oʻchiradi, faol obunani bekor qiladi va OctoMailni pochtangizdan uzadi.", body1B: "Buni qaytarib boʻlmaydi.",
        body2: "Hisoblaringizning oʻziga tegilmaydi: Gmail va Telegram hisoblaringiz qanday boʻlsa shunday qoladi va har bir xabar, jumladan OctoMail siz uchun yuborgan javoblar ham, joyida qoladi. Biz shunchaki kirish huquqini yoʻqotamiz.",
        delete: "Hisobni oʻchirish", confirm: "Ishonchingiz komilmi? Bu hamma narsani butunlay oʻchiradi va qaytarib boʻlmaydi.", deleting: "Oʻchirilmoqda…", yes: "Ha, hammasini oʻchirish", cancel: "Bekor qilish",
        fail: "Hisobingizni oʻchirib boʻlmadi. Qayta urinib koʻring.",
      },
    },
    help: {
      title: "Yordam", subtitle: "Biror narsada qiynalyapsizmi? Haqiqiy inson yordam beradi.", talk: "Inson bilan gaplashing", sameDay: "Odatda oʻsha kuni javob beramiz.", emailSupport: "Yordamga yozish",
      cantFindA: "Kerakli narsani topolmadingizmi? Yozing:", cantFindB: "va har bir xabarni haqiqiy inson oʻqiydi.",
      sections: [
        { title: "Boshlash", faqs: [
          { q: "OctoMail yangi soʻrovga qanchalik tez javob beradi?", a: "OctoMail yangi soʻrovni pochtangizga tushganidan bir necha soniya ichida oʻqiydi va javobni darhol tayyorlaydi. Avtopilot yoqilgan boʻlsa, avtomatik yuboradi, odatda bir daqiqa ichida, raqobatchi xatni ochishidan ancha oldin." },
          { q: "Texnik sozlash kerakmi?", a: "Yoʻq. Google yoki email orqali bir marta kirasiz, Gmail yoki Telegramni ulaysiz, qolganini OctoMail oʻzi qiladi: yoʻnaltirish qoidalari yoʻq, IT kerak emas, hech narsa oʻrnatilmaydi. Xabarlaringizni tekshira olsangiz, undan foydalana olasiz." },
          { q: "OctoMailni faqat Telegram bilan ishlatsam boʻladimi?", a: "Ha. Sozlash paytida Gmail oʻrniga Telegramni ulang (Telegram Premium kerak). Gmailni keyinroq istalgan vaqtda Bosh sahifadan qoʻshishingiz mumkin." },
          { q: "Yaxshi mijozni qanday aniqlaydi?", a: "Har bir xatni siz uchun muhim narsalarga qarab oʻqiydi (kim, nima kerak, muddat, manzil) va haqiqiy soʻrovlarni belgilab, spam va shunchaki soʻrab koʻruvchilarni chetga oladi. Buni Savollar sahifasida istalgan vaqtda sozlaysiz." },
          { q: "Soʻrovda yetarli maʼlumot boʻlmasa-chi?", a: "OctoMail soʻrovni «maʼlumot kerak» deb belgilaydi va faqat yetishmayotgan tafsilotlarni soʻraydigan doʻstona javob tayyorlaydi, shunda suhbat siz quvmasdan davom etadi." },
        ] },
        { title: "Javoblar va Avtopilot", faqs: [
          { q: "Mensiz xat yuboradimi?", a: "Faqat siz xohlasangiz. Qanday eshitilishini koʻrish uchun eng birinchi javobni siz tasdiqlaysiz. Keyin Avtopilot avtomatik yuboradi, va har bir javobni oʻzingiz koʻrib chiqish uchun Sozlamalarda istalgan vaqtda oʻchirishingiz mumkin." },
          { q: "U narx aytadimi yoki sanaga vaʼda beradimi?", a: "Yoʻq. Javoblar siz belgilamagan narx, sana yoki ish hajmiga hech qachon vaʼda bermaydigan qilib tuzilgan. U mijozni iliq qarshi oladi, tafsilotlarni sizga topshiradi." },
          { q: "Javoblar yordamchim yoki hamkorimga nusxa yubora oladimi?", a: "Ha. Sozlamalar → Nusxa yuborish boʻlimida qoʻshimcha manzil kiriting, OctoMail yuborgan har bir javob ularga ham boradi." },
        ] },
        { title: "Toʻlov", faqs: [
          { q: "Bepul sinov qanday ishlaydi?", a: "Har bir yangi hisob 7 kun bepul boshlanadi: toʻliq mahsulot, karta shart emas. Tayyor boʻlganingizda ilova ichida obuna boʻling; ungacha hech narsa yechilmaydi." },
          { q: "Qanday bekor qilaman?", a: "Sozlamalar → Toʻlovni boshqarish boʻlimida ikki bosish, yoki support@octoaiverse.com ga yozing, biz hal qilamiz. Toʻsiqlar yoʻq, ushlab qolish urinishlari yoʻq." },
          { q: "Qaysi valyutada toʻlayman?", a: "Kanadalik mijozlar CAD da, qolganlar USD da toʻlaydi. Ilovada koʻrgan narx, toʻlaydigan narxingiz." },
        ] },
        { title: "Maxfiylik va xavfsizlik", faqs: [
          { q: "Pochtam xavfsizmi?", a: "Ha. Biz Googlening rasmiy xavfsiz kirishi orqali ulanamiz, parolingiz OctoMailga hech qachon tegmaydi. Pochta maʼlumotlari shifrlangan holda saqlanadi, xatlaringiz hech kimga berilmaydi va sotilmaydi." },
          { q: "Pochtamni uzsam boʻladimi?", a: "Istalgan vaqtda. Sozlamalarda uzish barcha kirishni darhol toʻxtatadi. Hisobni oʻchirish OctoMailni Google hisobingizning ulangan ilovalaridan ham olib tashlaydi." },
          { q: "OctoMail xatlarimni oʻzgartiradi yoki oʻchiradimi?", a: "Hech qachon. U faqat soʻrovlarni topish uchun yangi kelgan xatlarni oʻqiydi va siz tasdiqlagan javoblarni yuboradi. U hech narsani belgilay, arxivlay, oʻzgartira yoki oʻchira olmaydi." },
        ] },
      ],
    },
    paywall: {
      title: "Bepul sinov muddatingiz tugadi", sub: "OctoMail email va Telegramdagi xabarlaringizni yigʻishda va soʻrovlarga javob berishda davom etishi uchun obuna boʻling.",
      held: (n: number) => n === 1 ? "Sinov toʻxtab turganda 1 ta soʻrov keldi" : `Sinov toʻxtab turganda ${n} ta soʻrov keldi`,
      heldNote: (n: number) => n === 1 ? "U hali oʻqilmagan va javob berilmagan. Obuna boʻling, OctoMail uni darhol saralaydi." : "Ular hali oʻqilmagan va javob berilmagan. Obuna boʻling, OctoMail ularni darhol saralaydi.",
      monthly: "Oylik", annual: "Yillik", save25: "25% tejang", redirecting: "Yoʻnaltirilmoqda…", subscribe: "Obuna boʻlish va soʻrovlarni saqlab qolish", signOut: "Chiqish",
    },
    trial: {
      daysLeft: (n: number) => `Bepul sinovingizga ${n} kun qoldi`,
      endsToday: "Sinov muddatingiz bugun tugaydi",
    },
    home: {
      srTitle: "Bosh sahifa: kunlik xulosa",
      declined: "Siz ruxsat bermadingiz. Pochtaga kirishsiz OctoMail soʻrovlarni oʻqiy olmaydi.",
      tryAgain: "Qayta urinish",
      noRefreshA: "Google yangilash tokenini qaytarmadi. Iltimos, bu ilovani",
      noRefreshLink: "Google hisobingiz ruxsatlaridan",
      noRefreshB: "uzing va qayta urinib koʻring.",
      connectError: "Pochtangizni ulashda xatolik yuz berdi. Qayta urinib koʻring.",
      gmailConnected: (email: string) => `Gmail ulangan · ${email}`,
      gettingSetUp: "Sozlanmoqda",
      needsYou: "Sizni kutmoqda",
      caughtUp: "Hammasi bajarilgan.",
      statNew: "Yangi soʻrovlar",
      statReplied: "Javob berildi",
      statNeeds: "Sizni kutmoqda",
      last7: "Soʻrovlar · oxirgi 7 kun",
      today: "Bugun",
      howItWorks: "Qanday ishlaydi",
      handledBy: "Avtopilot bajardi",
      pipelineIntro: "Endi har bir xat bilan shunday boʻladi:",
      pipelineIntroTelegram: "Endi har bir yangi xabar bilan shunday boʻladi:",
      noRepliesYet: "Hali javoblar yoʻq.",
      viewAllHandled: "Barcha bajarilganlarni koʻrish →",
      viewAllNeeds: (n: number) => `Barchasi (${n}) Mijozlar boʻlimida →`,
      savedA: (mins: number) => `~${mins} daqiqa`,
      savedB: " shu hafta javoblarda tejaldi.",
      outcomes: "Javob natijalari",
      days30: "30 kun",
      writeBack: (pct: number) => `Mijozlarning ${pct}% qayta yozadi`,
      responded: "Javob berdi",
      waiting: "Kutilmoqda",
      cold: "Sovuq",
      ofWroteBack: (r: number, s: number) => `${s} tadan ${r} tasi qayta yozdi`,
      coldNote: "3 kun javob boʻlmasa, soʻrov sovuq hisoblanadi.",
      comingSoon: "Tez orada",
      roadmap: ["Outlook va Microsoft 365", "Band qilingan ishlar uchun kalendar", "Bir nechta pochta"],
      newLead: "Yangi soʻrov",
      channels: {
        aria: "Ulangan kanallar",
        gmail: "Gmail",
        telegram: "Telegram",
        email: "Elektron pochta",
        connectGmail: "Gmailni ulash",
        reconnectGmail: "Gmailni qayta ulash",
        connectTelegram: "Telegramni ulash",
        telegramRepliesOff: "Telegram: javoblar oʻchiq",
        telegramFinish: "Telegram: sozlashni yakunlang",
      },
      reasons: {
        complaint: "Shikoyat",
        existingCustomer: "Mavjud mijoz",
        media: "Ovozli xabar yoki fayl",
        aiPaused: "AI toʻxtatildi",
        replySoon: "Tezroq javob bering",
        draftReady: "Qoralama tayyor",
        queued: "Navbatda",
        open: "Ochiq",
      },
      lead: "Soʻrov",
      replied: "Javob berildi",
      leadCount: (n: number) => `${n} ta soʻrov`,
      autopilotRepliedIn: (speed: string) => `Avtopilot soʻrov kelganidan ${speed} keyin javob berdi`,
      there: "doʻstim",
      dow: ["Y", "D", "S", "C", "P", "J", "S"],
      brief: {
        morning: "Xayrli tong",
        afternoon: "Xayrli kun",
        evening: "Xayrli kech",
        quiet: "Hozircha tinch, sizni hech narsa kutmayapti. Yangi soʻrovlar kelishi bilan shu yerda koʻrsataman.",
        repliedWeek: (n: number) => `Siz va Avtopilot shu hafta ${n} ta soʻrovga javob berdingiz.`,
        noReplies: "Shu hafta hali javoblar yuborilmadi.",
        nothingNeeds: "Hozir sizni hech narsa kutmayapti.",
        waitingOnYou: (n: number) => `${n} ta soʻrov sizni kutmoqda.`,
      },
      clock: { yourAssistant: "Sizning yordamchingiz", eyebrow: "Kunlik xulosa", live: "● jonli", currentTime: (t: string) => `Hozirgi vaqt ${t}` },
      firstRun: {
        pipeline: [
          { title: "Mijoz sizga xat yozadi", sub: "Pochtangizga kelgan har qanday soʻrov." },
          { title: "OctoMail oʻqiydi va baholaydi", sub: "Haqiqiy xaridorlar ichkariga, spam chetga." },
          { title: "Siz yozgandek javob tayyorlanadi", sub: "Iliq, shaxsiy, oʻylab topilgan narxlarsiz." },
          { title: "Birinchisini siz tasdiqlaysiz", sub: "Keyin Avtopilot oʻzi bajaradi." },
        ],
        pipelineTelegramFirst: { title: "Mijoz sizga yozadi", sub: "Telegramingizdagi har qanday yangi chat." },
        pipelineTelegramLast: { title: "Darhol javob beradi", sub: "Faqat siz ruxsat bergan chatlarda, oʻzingiz javob bersangiz toʻxtaydi." },
        connectLabel: "Gmailni ulang",
        connectSub: "Bajarildi. OctoMail pochtangizni kuzatmoqda.",
        tuneLabel: "Saralash savollaringizni sozlang",
        tuneSub: "Biznesingiz uchun yaxshi mijoz qanday boʻlishini ayting.",
        tuneCta: "Savollarni koʻrish",
        testLabel: "Oʻzingizga sinov soʻrovi yuboring",
        testSub: "Oʻz pochtangizga narx soʻrovi yozing va uning saralanishini kuzating.",
        testCta: "Sinov xati yuborish",
        tgConnectLabel: "Telegramni ulang",
        tgConnectSub: "Bajarildi. OctoMail Telegramdagi yangi mijozlar chatlariga javob beradi.",
        tgFinishLabel: "Telegramni sozlashni yakunlang",
        tgFinishCta: "Telegram sozlamalarini ochish",
        tgTestLabel: "Sinov xabarini yuboring",
        tgTestSub: "Kontaktlaringizda boʻlmagan kishidan Telegramingizga yozishini soʻrang va OctoMail qanday javob berishini kuzating.",
        testSubject: "Narx soʻrovi: oshxona taʼmiri",
        testBody: "Salom! Kuzda oshxonani taʼmirlamoqchimiz va shu hafta narxlarni yigʻyapmiz. Byudjet taxminan 30 million soʻm, oktyabrda boshlamoqchimiz. Taxminiy narx va boʻsh vaqtingizni yuborib bera olasizmi?\n\nRahmat,\nA. Mijoz",
      },
    },
    leads: {
      title: "Soʻrovlar",
      subtitle: "Har bir kelgan soʻrov, savollaringiz boʻyicha baholangan.",
      loadingAria: "Soʻrovlar yuklanmoqda",
      noLeadsYet: "Hali soʻrovlar yoʻq",
      noLeadsBody: "Kelgan xatlar bilan birga bu yerda avtomatik paydo boʻladi.",
      noOpen: "Ochiq soʻrovlar yoʻq. Hammasi bajarilgan.",
      noSnoozed: "Hozir kechiktirilganlar yoʻq.",
      noDone: "Hali yakunlangan soʻrovlar yoʻq.",
      noFiltered: "Hali hech narsa saralab chiqarilmagan.",
      noMatch: "Bu filtrga mos soʻrovlar yoʻq.",
      notLeadBody: "Yangiliklar, cheklar va bildirishnomalar shu yerga tushadi, haqiqiy soʻrovlaringiz emas.",
      tryAdjust: "Yuqoridagi qidiruv, holat yoki toifa filtrlarini oʻzgartirib koʻring.",
      firstRun: {
        eyebrow: "Birinchi soʻrovingiz kutilmoqda",
        title: "Soʻrovlaringiz shu yerga tushadi, allaqachon oʻqilgan, baholangan va javob berilgan holda.",
        watchingA: "OctoMail kuzatmoqda:",
        yourInbox: "pochtangiz",
        yourTelegram: "Telegram chatlaringiz",
        andTelegram: " va Telegram chatlaringiz",
        yourChannels: "ulangan kanallaringiz",
        watchingB: ". Soʻrov kelgan zahoti u shu roʻyxatda hamma narsa ajratilgan holda paydo boʻladi: kim yozgan, nima kerak va tayyorlangan javob.",
        sendTest: "Oʻzingizga sinov soʻrovi yuboring",
        reviewQuestions: "Savollaringizni koʻring",
        testNote: "Sinov xati oddiy soʻrov kabi keladi va taxminan bir daqiqada saralanadi.",
        pipelineEyebrow: "Har bir xat bilan nima boʻladi",
        pipelineEyebrowMessages: "Har bir xabar bilan nima boʻladi",
      },
      buckets: { attention: "Eʼtiboringiz kerak", open: "Ochiq", snoozed: "Kechiktirilgan", done: "Bajarilgan", notlead: "Soʻrov emas" },
      noAttention: "Hozircha shaxsan sizni kutayotgan xabar yoʻq.",
      attentionBody: "Shikoyatlar va mavjud mijozlarning xabarlari shu yerga tushadi. OctoMail ularga hech qachon avtomatik javob bermaydi.",
      attentionKind: { complaint: "Shikoyat", existing_customer: "Mavjud mijoz" },
      attentionBanner: "Bu xabar shaxsan sizni talab qiladi. OctoMail avtomatik javob bermadi, shuning uchun biror narsa yuborishdan oldin qoralamani koʻrib chiqing.",
      pendingBanner: "OctoMail bu xatni saqladi, lekin hali oʻqiy olmadi. Har 30 daqiqada avtomatik qayta urinadi.",
      bucketAria: "Soʻrovlar boʻlimi",
      searchPlaceholder: "Soʻrovlarni qidirish…",
      searchAria: "Soʻrovlarni qidirish",
      attachments: (n: number) => `${n} ta ilova`,
      replied: "Javob berildi",
      telegramBadge: "Telegram",
      mediaChip: "Ovozli xabar yoki fayl",
      aiPausedCap: "AI toʻxtatildi: bu oy uchun limit tugadi. Oʻzingiz javob bering; limit har oyning 1-sanasida yangilanadi.",
      aiPausedDaily: "AI bugunga toʻxtatildi: kunlik xavfsizlik limiti.",
      panel: {
        back: "‹ Soʻrovlar",
        close: "Yopish",
        noQuestionsA: "Saralash savollarini qoʻshing, OctoMail har bir soʻrovdan javoblarni (byudjet, muddat, manzil) ajratib beradi.",
        setThemUp: "Sozlash →",
        notProvided: "koʻrsatilmagan",
        snooze: "Kechiktirish",
        s1d: "1 kun",
        s3d: "3 kun",
        s1wk: "1 hafta",
        notInterested: "Qiziq emas",
        unsnoozeUntil: (d: string) => `Qaytarish (${d} gacha)`,
        reopen: "Qayta ochish",
      },
    },
    login: {
      homeAria: "OctoMail bosh sahifasiga oʻtish",
      welcomeBack: "Xush kelibsiz",
      createAccount: "Hisob yarating",
      signInSub: "Mijozlaringizni boshqarish uchun OctoMailga kiring.",
      signUpSub: "Bir necha daqiqada mijozlaringizni saralashni boshlang.",
      redirecting: "Yoʻnaltirilmoqda…",
      continueGoogle: "Google orqali davom etish",
      oneTap: "Bir bosish pochtangizni ham ulaydi, qoʻshimcha qadam yoʻq.",
      reviewA: "Google hozir OctoMailni tekshirishni yakunlamoqda, shuning uchun keyingi ekranda ogohlantirish chiqishi mumkin. Davom etish uchun",
      reviewAdvanced: "Advanced → Go to OctoMail",
      reviewB: "ni tanlang. Maʼlumotlaringiz maxfiy va xavfsiz qoladi.",
      or: "yoki",
      email: "Elektron pochta",
      emailPlaceholder: "siz@kompaniya.uz",
      password: "Parol",
      loading: "Yuklanmoqda…",
      signIn: "Kirish",
      createAccountBtn: "Hisob yaratish",
      newTo: "OctoMailda yangimisiz?",
      createAnAccount: "Hisob yarating",
      already: "Hisobingiz bormi?",
      agreeA: "Davom etish orqali siz bizning",
      terms: "Shartlar",
      and: "va",
      privacy: "Maxfiylik siyosati",
      agreeB: "ga rozilik bildirasiz.",
      errors: {
        badCredential: "Elektron pochta yoki parol notoʻgʻri.",
        emailInUse: "Bu elektron pochta bilan hisob allaqachon mavjud.",
        weakPassword: "Parol kamida 8 ta belgidan iborat boʻlishi kerak.",
        cancelled: "Kirish bekor qilindi.",
        network: "Tarmoq xatosi. Ulanishni tekshirib, qayta urinib koʻring.",
        generic: "Nimadir xato ketdi.",
      },
    },
    onboarding: {
      title: "Keling, sozlab olamiz",
      subtitle: "Uch tez qadam va OctoMail siz uchun ishlay boshlaydi.",
      stepOf: (n: number, total: number) => `${total} qadamdan ${n}-si`,
      s1Title: "Kanallaringizni ulang",
      s1Body: "Mijozlaringiz sizga qayerda yozishini tanlang. Boshlash uchun bitta kanal yetarli, ikkinchisini istalgan vaqtda qoʻshishingiz mumkin.",
      gmailBody: "OctoMail kelgan soʻrovlarni oʻqiydi, shunda ularni saralab, javob bera oladi. Parolingiz Googledan tashqariga chiqmaydi.",
      channelDone: "Ulandi",
      channelsLabel: "Kanallar",
      repliesOff: "Javoblar oʻchiq",
      s1Busy: "Google ochilmoqda…",
      s1Btn: "Gmailni ulash",
      s2Title: "Yaxshi mijozni nima belgilashini tanlang",
      s2Body: "Sizni 6 ta keng tarqalgan savol bilan boshlaymiz (loyiha turi, manzil, byudjet, muddat…). Ularni istalgan vaqtda tahrirlashingiz mumkin.",
      s2Busy: "Qoʻshilmoqda…",
      s2Btn: "Tayyor toʻplamdan foydalanish",
      s2Manual: "Qoʻlda sozlash",
      s3Title: "Hammasi tayyor",
      s3TitleAlmost: "Deyarli tayyor",
      s3Body: "OctoMail endi pochtangizni kuzatmoqda. Yangi soʻrovlar avtomatik ravishda mijozlar sifatida koʻrinadi.",
      s3BodyTelegram: "OctoMail endi Telegram chatlaringizni kuzatmoqda. Yangi xabarlar avtomatik ravishda mijozlar sifatida koʻrinadi.",
      s3BodyBoth: "OctoMail endi pochtangiz va Telegram chatlaringizni kuzatmoqda. Yangi soʻrovlar avtomatik ravishda mijozlar sifatida koʻrinadi.",
      s3Btn: "Mijozlarimga oʻtish",
    },
  },
  meta: {
    title: "OctoMail: har bir mijozga javob beriladi",
    description: "OctoMail email va Telegramdagi har bir yangi xabarni oʻqiydi, bir daqiqa ichida sizning ohangingizda va mijoz tilida javob beradi. 7 kun bepul sinab koʻring.",
    ogDescription: "Email va Telegramdagi har bir yangi xabarni oʻqiydi, bir daqiqa ichida javob beradi va haqiqiy xaridorlarni sizga topshiradi.",
    ogImageAlt: "OctoMail: har bir mijozga javob beriladi.",
  },
};
